import { BasicCommand } from "./BasicCommand";
/**
 * Created by tschenkel on 1/6/2015.
 */


import { BasicController } from "../BasicController";
import { BasicSmartfoxConstants } from "../BasicSmartfoxConstants";
import {CoreErrorIdConstants} from "@goodgamestudios/shared-constants";
import {GenerateInviteCodeEvent} from "../../event/GenerateInviteCodeEvent";

/**
 * Command used to generate a invite code.
 *
 * Documentation see here:
 * https://sites.google.com/a/goodgamestudios.com/tech-wiki/java/gamedocumentation/core/events/generateinvitecodeevent
 */
export class GICCommand extends BasicCommand {
    protected get cmdId(): string {
        return BasicSmartfoxConstants.S2C_GENERATE_INVITE_CODE;
    }

    public executeCommand(error: number, params: any[]): boolean {
        let success: boolean = false;

        switch (error) {
            case CoreErrorIdConstants.OK:
                success = true;

                let inviteCodeOrLink: string = String(params.pop());

                if (inviteCodeOrLink.includes("?")) {
                    let parts: string[] = inviteCodeOrLink.split("?");
                    let separator: string = this.env.href.includes("?") ? "&" : "?";
                    inviteCodeOrLink = this.env.href + separator + parts[1];
                }

                BasicController.getInstance().dispatchEvent(new GenerateInviteCodeEvent(GenerateInviteCodeEvent.INVITE_CODE_GENERATED, error, inviteCodeOrLink));
                break;

            case CoreErrorIdConstants.FEATURE_NOT_AVAILABLE:
            case CoreErrorIdConstants.INVALID_PARAMETER_VALUE:
            case CoreErrorIdConstants.GENERAL_ERROR:
            case CoreErrorIdConstants.FRIENDINVITE_CODE_CREATION_ERROR:
            case CoreErrorIdConstants.FRIENDINVITE_CODE_CREATION_UNKNOWN_TYPE:
            case CoreErrorIdConstants.FRIENDINVITE_CODE_CREATION_NO_LINK_CONFIGURED:
                BasicController.getInstance().dispatchEvent(new GenerateInviteCodeEvent(GenerateInviteCodeEvent.GENERATE_INVITE_CODE_FAILED, error));
                break;
        }
        return success;
    }
}

